import styled from 'styled-components';

export const SlideContainer = styled.div`
	width: 100%;
	position: relative;
	height: calc(100dvh - 48px);

	overflow: scroll;
	&::-webkit-scrollbar {
		display: none;
	}
`;

export const BottomButtonContainer = styled.div`
	width: 100vw;
	max-width: 768px;
	padding: 15px 24px;
	background-color: white;

	display: flex;
	flex-direction: column;
	align-items: center;
	gap: 10px;

	position: fixed;
	bottom: 0px;
`;

export const TermsSlide = styled.div`
	width: 100%;
	padding: 20px;
	padding-bottom: 102px;

	display: flex;
	flex-direction: column;
	justify-content: flex-start;
	gap: 28px;
`;

export const FavoriteList = styled.div`
	width: 100%;
	display: grid;
	grid-template-columns: repeat(auto-fit, minmax(100px, auto));
	gap: 10px;
`;

export const FavoriteItem = styled.label<{ isChecked: boolean }>`
	padding: 12px 0px;
	box-sizing: content-box;

	border-radius: 6px;
	/* border: 1px solid ${({ theme }) => theme['warmgray-300']}; */
	border: 1px solid rgba(210, 200, 195, 0.6);

	background-color: ${({ theme, isChecked }) =>
		isChecked ? theme['orange-secondary'] : theme.white};

	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	flex-shrink: 0;
`;

export const FavoriteIcon = styled.span`
	font-size: 24px;
	line-height: 30px;
`;
